import { InjectionToken } from '@angular/core';
import { Environment } from '@shared/models/platform/environment.models';

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
